/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Form, Formik } from "formik";
import { pathOr, includes } from "ramda";
import * as Yup from "yup";
import * as jwt from "jsonwebtoken";

import UserService from "../../service/UserService";
import loginService from "../../service/login";
import { LoginSagaAction, checkUserExist } from "../../sagas/saga-actions";
import { setPopup } from "../../actions/popupAction";
import CustomButton from "../customButton";
import CustomNotification from "../notification";
import LoginLeftSection from "../loginLeftSection";
import { SingleFormikSelect } from "../select/singleSelect";
import { removeCookie } from "../../helper/helpers";
import { getCookie } from "../../helper/helpers";
import {
  LIVECHAT_DOMAIN,
  PRACTICE_EDITION_WHITELABEL,
  TOKEN_NAMES,
} from "../../constants/constants";
import LoadingSpinner from "../loadingSpinner";

const AdminLogin = (props) => {
  const userservice = new UserService();
  const history = useHistory();

  const msToken = getCookie(TOKEN_NAMES.MS);
  const decodedMSToken = jwt.decode(msToken, { complete: true });

  const role =
    props?.location?.state?.role || decodedMSToken?.payload?.roles?.roleKey;
  const userId = props?.location?.state?.userId;
  const url = props?.location?.state?.url;
  const sso = props?.location?.state?.sso;
  const [state, setState] = useState({
    initialValuesLogin: {
      accountName: "",
      userName: "",
    },
    accountsList: [],
    userList: [],
  });

  const { customPopupMessage, messageType, message } = props.popupReducer;

  const credentialSchema = Yup.object().shape({
    accountName: Yup.object().shape({
      id: Yup.string().required("Account name is required"),
    }),
    userName:
      !["HA", "CR"].includes(role) &&
      Yup.object().shape({
        id: Yup.string().required("User name is required"),
      }),
  });
  const checkOtp = async () => {
    if (!userservice.getToken() && !userservice.getMsToken()) {
      history.push("/");
    }
  };
  const checkLogin = async () => {
    if (loginService.isLoggedin() && !userservice.getMsToken()) {
      history.push("/chat");
    }
  };

  useEffect(
    () => {
      if (!sso) {
        checkLogin();
        checkOtp();
      } else if (userId) {
        handleVerifyAdmin(userId);
      }
    },
    [sso]
  );

  const handleGoBack = () => {
    userservice.removeToken();
    userservice.removeMsTokens();
    history.push("/");
  };

  const handleVerifyAdmin = async (id, e) => {
    if (e) e.preventDefault();
    try {
      const response = await userservice.loginWithAdmin(id);
      const { userDetails } = response;
      const mainOrSub = userDetails?.lcUser?.mainOrSub;
      const role = ["HA", "CR"].includes(userDetails?.roles.roleKey)
        ? userDetails?.roles?.roleKey
        : userDetails?.lcUser?.roles?.roleKey;

      if (userDetails?.directLoginLC === 0) {
        history.push({
          pathname: "/login-by-dept",
          state: {
            mainOrSub,
            role,
            roleType: userDetails?.roleType,
          },
        });
      } else {
        if (!userDetails.practiceId) {
          props.setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: `Invalid credentials!`,
          });
          return;
        }
        if (["HA", "CR"].includes(role)) {
          loginService.doLogin(response?.userDetails, "", "");
        } else {
          loginService.doAdminLogin(response?.userDetails, "", "");
        }
        props.LoginSagaAction(userDetails);
        props.setPopup({
          customPopupMessage: true,
          messageType: "success",
          message: `${loginService &&
            loginService.getName()} logged in Successfully`,
        });
        removeCookie(
          "ms-lc-token",
          process.env.REACT_APP_ENV !== "dev" && {
            domain: LIVECHAT_DOMAIN,
          },
          false
        );
        removeCookie(
          TOKEN_NAMES.MS_LOGIN,
          process.env.REACT_APP_ENV !== "dev" && {
            domain: LIVECHAT_DOMAIN,
          },
          false
        );

        const {
          liveChatAccess,
          broadcastAccess,
          liveAgentAccess,
          reportOnlyAccess,
        } = userDetails;
        if (PRACTICE_EDITION_WHITELABEL && url) {
          props.history.push(url);
          return;
        }

        if (liveChatAccess || reportOnlyAccess) {
          history.push("/chat");
        } else if (liveAgentAccess) {
          history.push("/chat-agent");
        } else if (broadcastAccess || reportOnlyAccess) {
          history.push("/broadcast");
        } else {
          loginService.Logout();
          props.setPopup({
            customPopupMessage: true,
            message: "You do not have access",
            messageType: "error",
          });
          history.push("/login");
        }
      }
    } catch (err) {
      if (
        includes(
          401,
          pathOr(
            "Internal Server Error. Please check the connection",
            ["response", "data", "error"],
            err
          )
        )
      ) {
        history.push("/login");
      }
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Internal Server Error. Please check the connection",
          ["response", "data", "message"],
          err
        ),
        messageType: "error",
      });
    }
  };

  const fetchAccounts = (page = 1, searchQuery, isScrolling) => {
    return new Promise(async (resolve, reject) => {
      try {
        let accountsList = [];
        let count = 0;
        if (["HA", "CR"].includes(role)) {
          const responseData = await userservice.getAccountsForHA(
            page,
            searchQuery
          );
          accountsList = responseData.rows;
          count = responseData.count;
        } else {
          const responseData = await userservice.getPortalAccountsForAdmin(
            page,
            searchQuery,
            15
          );
          accountsList = responseData.rows;
          count = responseData.count;
        }
        setState((st) => ({
          ...st,
          accountsList: isScrolling
            ? [...st.accountsList, ...accountsList]
            : accountsList,
        }));
        resolve(count);
      } catch (err) {
        reject(err);
        props.setPopup({
          customPopupMessage: true,
          message: pathOr(
            "Internal Server Error. Please check the connection",
            ["response", "data", "message"],
            err
          ),
          messageType: "error",
        });
      }
    });
  };

  if (userId) {
    return <LoadingSpinner />;
  }
  return (
    <div data-testid="login-page-wrapper" className="login-page-wrapper">
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}
      <main className="login-page-main">
        <LoginLeftSection />

        <section className="form-wrapper">
          <h2 className="form-heading">Select Account and User</h2>
          <Formik
            enableReinitialize
            initialValues={state?.initialValuesLogin}
            validationSchema={credentialSchema}
            validateOnMount
            isInitialValid={!!state?.isInitialValid}
          >
            {({ isValid, values, setFieldValue, validateForm }) => {
              const fetchUsers = (page = 1, searchQuery, isScrolling) => {
                const { practiceId } = values?.accountName || {};
                return new Promise(async (resolve, reject) => {
                  if (practiceId) {
                    try {
                      const {
                        rows: userList = [],
                        count = 0,
                      } = await userservice.getPortalUsersForAdmin(
                        practiceId,
                        page,
                        searchQuery
                      );
                      setState((st) => ({
                        ...st,
                        userList: isScrolling
                          ? [...st.userList, ...userList]
                          : userList,
                      }));
                      resolve(count);
                    } catch (err) {
                      reject(err);
                      props.setPopup({
                        customPopupMessage: true,
                        message: pathOr(
                          "Internal Server Error. Please check the connection",
                          ["response", "data", "message"],
                          err
                        ),
                        messageType: "error",
                      });
                    }
                  } else {
                    resolve([]);
                    setFieldValue("userName", {});
                    setState((st) => ({
                      ...st,
                      userList: [],
                    }));
                  }
                });
              };

              return (
                <Form className="login-form">
                  <section className="custom-input-group name-field">
                    <SingleFormikSelect
                      data={state.accountsList}
                      name="accountName"
                      onChange={() => {
                        setTimeout(validateForm, 0);
                        setFieldValue("userName", {});
                      }}
                      optionLabelProp="name"
                      optionValueProp="id"
                      placeholder="Select account name"
                      required
                      title="Account Name"
                      infiniteScroll
                      loadMoreData={fetchAccounts}
                    />
                  </section>

                  {!["HA", "CR"].includes(role) && (
                    <section className="custom-input-group name-field">
                      <SingleFormikSelect
                        data={state.userList}
                        name="userName"
                        key={values.accountName?.practiceId}
                        onChange={() => setTimeout(validateForm, 0)}
                        optionLabelProp="username"
                        optionValueProp="id"
                        placeholder="Select user name"
                        required
                        title="User Name"
                        infiniteScroll
                        loadMoreData={fetchUsers}
                      />
                    </section>
                  )}

                  <article className="otp-buttons">
                    <CustomButton
                      htmlType="submit"
                      type="primary"
                      className={!isValid ? "disable-button" : null}
                      disabled={!isValid}
                      title="Submit"
                      onClick={(e) =>
                        handleVerifyAdmin(
                          ["HA", "CR"].includes(role)
                            ? values.accountName?.practice_id
                            : values?.userName?.id,
                          e
                        )
                      }
                    />
                    <CustomButton
                      htmlType="submit"
                      type="primary"
                      className="cancel-button ml-8"
                      onClick={handleGoBack}
                      title="Go Back"
                    />
                  </article>
                </Form>
              );
            }}
          </Formik>
        </section>
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    popupReducer: state.popupReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    LoginSagaAction: (data) => {
      dispatch(LoginSagaAction(data));
    },
    checkUserExist: (data) => dispatch(checkUserExist(data)),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdminLogin)
);
